'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PRODUCT_VERSION } from 'self-service-api/constants/SkuTypes';
import { skuSelector } from '../../selectors/ProductsSelectors';
import { PlanBuilderContext } from './PlanBuilder';
import QuantityPacksPickerContainer from './QuantityPacksPickerContainer';

const SuiteQuantityPackPickers = ({
  setProductLevel
}) => {
  const {
    productConfigurations,
    trackingSource
  } = useContext(PlanBuilderContext);
  const quantityPacksSkuIds = useSelector(state => productConfigurations.reduce((acc, {
    skuId
  }) => {
    const sku = skuSelector(state, {
      skuId
    });

    if (sku.skuType === PRODUCT_VERSION) {
      return [...acc, ...sku.quantityPackDetails.map(({
        skuId: quantityPackSkuId
      }) => quantityPackSkuId)];
    }

    return acc;
  }, []));
  return /*#__PURE__*/_jsx(QuantityPacksPickerContainer, {
    quantityPackSkuIds: quantityPacksSkuIds,
    setProductLevel: setProductLevel,
    trackingSource: trackingSource
  });
};

export default SuiteQuantityPackPickers;